import { createModel } from '@/store/tools';

const model = {
    namespace: 'menuconfig',
    build: (T, A, S, R, C) => ({
        actiontypes: {
            'getAllMenuList': T('getAllMenuList'),
        },
        actions: {
            'getAllMenuList': A('getAllMenuList'),
        },
        sagas: {
            'getAllMenuList': S('getAllMenuList', '/?cmd=com.xqxc.api.pig.mis.biz.account.MenuMisService.listAllMenuInfo'),
        },
        reducers: {
            'getAllMenuList': R('getAllMenuList', []),
        }
    })
};
export default createModel(model);